import React from 'react'
import styles from './styles.css'
import Tooltip from '@orionx-dev/orionsoft-parts/lib/components/Tooltip'
import PropTypes from 'prop-types'

function UnderscoreLink({onClick, children, tooltip}) {
  return (
    <Tooltip content={tooltip || undefined}>
      <span onClick={() => onClick()} className={styles.underscore}>
        {children}
      </span>
    </Tooltip>
  )
}

UnderscoreLink.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.any,
  tooltip: PropTypes.string
}

export default UnderscoreLink
